import { render, staticRenderFns } from "./weekSummary.vue?vue&type=template&id=40fded5a&scoped=true"
import script from "./weekSummary.vue?vue&type=script&lang=js"
export * from "./weekSummary.vue?vue&type=script&lang=js"
import style0 from "./weekSummary.vue?vue&type=style&index=0&id=40fded5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fded5a",
  null
  
)

export default component.exports